var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.45166,
    y: 0.945312,
    width: 27,
    height: 25,
    rx: 3.52394,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7420_41967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9953 9.5V19.0929C18.9953 19.7781 18.3101 20.4634 17.6249 20.4634H10.7728C10.0876 20.4634 9.40234 19.7781 9.40234 19.0929V9.5",
    stroke: "#A5A5A5",
    strokeWidth: 1.37042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8291 12.9258V17.037",
    stroke: "#A5A5A5",
    strokeWidth: 1.37042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5688 12.9258V17.037",
    stroke: "#A5A5A5",
    strokeWidth: 1.37042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03174 9.5H20.3655",
    stroke: "#A5A5A5",
    strokeWidth: 1.37042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.458 9.5006V8.13019C11.458 7.44498 12.1432 6.75977 12.8284 6.75977H15.5693C16.2545 6.75977 16.9397 7.44498 16.9397 8.13019V9.5006",
    stroke: "#A5A5A5",
    strokeWidth: 1.37042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7420_41967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.445,
    height: 16.445,
    fill: "white",
    transform: "translate(5.97607 5.38867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3089adde54bc4358cd9e10b15f9e4e49.svg";
export { ForwardRef as ReactComponent };